// @flow
import React from 'react';
import { connect } from 'react-redux';
import i18n from 'app/common/lib/i18n';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Dispatch } from 'redux';
import type { State } from 'app/common/redux/types';
import { compose } from 'redux';
import { IconButton } from 'gestalt';
import { withInboxContext } from 'app/common/react/components/growth/news/ConversationsPanel/InboxButtonController';
import {
  OpenConversationsDropdown,
  CloseConversationsDropdown,
} from 'app/common/redux/actions/notifications';
import {
  type Conversation,
  conversationCreate,
  conversationOpen,
} from 'app/common/redux/actions/conversations';

type OwnProps = {|
  creatorUserId: string,
  setProfileInboxButton: (ref: ?HTMLElement) => void,
|};

type ReduxProps = {|
  closeConversationsDropdown: () => void,
  conversationCreate: (conversation: Conversation) => void,
  openConversation: (conversationId: string) => void,
  openConversationsDropdown: () => void,
  showPanel: boolean,
|};

type Props = {| ...OwnProps, ...ReduxProps |};

export class CreatorMessageButton extends React.Component<Props> {
  anchor: ?HTMLElement;

  setButtonRef = (ref: ?HTMLElement) => {
    const { setProfileInboxButton } = this.props;
    if (!this.anchor) {
      this.anchor = ref;
      setProfileInboxButton(ref);
    }
  };

  handleButtonClick = () => {
    const {
      showPanel,
      closeConversationsDropdown,
      conversationCreate,
      openConversation,
      openConversationsDropdown,
    } = this.props;
    if (showPanel) {
      closeConversationsDropdown(); // From dispatchConversationsDropdown
    } else {
      const sendMessageResource = ResourceFactory.create('ConversationsResource', {
        user_ids: [this.props.creatorUserId],
      });
      sendMessageResource.callCreate().then((response) => {
        const conversation = response && response.resource_response.data;
        conversationCreate(conversation);
        openConversation(conversation.id);
        openConversationsDropdown(); // From dispatchConversationsDropdown
      });
    }
  };

  render() {
    return (
      <div ref={this.setButtonRef}>
        <IconButton
          accessibilityLabel={i18n._(
            'Profile message button',
            'Accessible label for button to open conversation with creator',
          )}
          bgColor="lightGray"
          icon="speech-ellipsis"
          size="sm"
          onClick={this.handleButtonClick}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: State) => ({
  showPanel: state.ui.notifications && state.ui.notifications.showConversationsDropdown,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  conversationCreate: (conversation) => dispatch(conversationCreate(conversation)),
  openConversation: (conversationId) => dispatch(conversationOpen(conversationId)),
  openConversationsDropdown: () => dispatch(OpenConversationsDropdown),
  closeConversationsDropdown: () => dispatch(CloseConversationsDropdown),
});

export default compose(
  withInboxContext,
  connect<Props, OwnProps, _, _, _, _>(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(CreatorMessageButton);
